// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__timlE","wrapper":"Privacy_wrapper__llP19","logo":"Privacy_logo__tB0F+","heading":"Privacy_heading__BYA2b"};